import type { RouteObject } from "react-router-dom";

export const fraudReviewRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Fraud Review Dashboard" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { FraudReviewPage } = await import("./fraud-review-page");
          return { Component: FraudReviewPage };
        },
      },
    ],
  },
];
